export default "__VITE_ASSET__3e5eb59e__"